import type React from "react"
import { mergeClasses } from "../../../../utils/css"
import { Button, ButtonColor, ButtonSize, Typography } from "../../../common"
import "./DesktopConfirmationModal.scss"

interface DesktopConfirmationModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    title: string
    message: string
    additionalInfo?: string
    cancelText: string
    confirmText: string
}

export const DesktopConfirmationModal: React.FC<
    DesktopConfirmationModalProps
> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    additionalInfo,
    cancelText,
    confirmText,
}) => {
    if (!isOpen) return null

    const handleContentClick = (e: React.MouseEvent) => {
        e.stopPropagation()
    }

    return (
        <div
            className="modal-overlay"
            data-testid="confirmation-modal"
            onClick={onClose}
        >
            <div className="modal-content" onClick={handleContentClick}>
                <div className="modal-header">
                    <Typography
                        className="modal-title"
                        component="h3"
                        weight="medium"
                        size="md"
                    >
                        {title}
                    </Typography>
                </div>

                <Typography component="h3" weight="normal" size="sm">
                    {message}
                </Typography>

                {additionalInfo && (
                    <Typography component="h3" weight="normal" size="sm">
                        {additionalInfo}
                    </Typography>
                )}

                <div
                    className={mergeClasses(
                        "modal-footer",
                        additionalInfo ? "has-additional-info" : "",
                    )}
                >
                    <div className="modal-buttons">
                        <Button
                            color={ButtonColor.Clear}
                            size={ButtonSize.Large}
                            text={cancelText}
                            className="modal-button modal-button--cancel"
                            onClick={onClose}
                        />
                        <Button
                            // Use optional prop or default
                            color={ButtonColor.Blue}
                            size={ButtonSize.Large}
                            text={confirmText}
                            // Apply specific class if needed, or make className a prop too
                            className="modal-button modal-button--confirm" // Renamed for clarity
                            onClick={onConfirm}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
